var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_2",
    "data-name": "Layer 2",
    viewBox: "0 0 32 32",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27,8H24.49a9,9,0,0,0-17,0H5a3,3,0,0,0-3,3V27a3,3,0,0,0,3,3H27a3,3,0,0,0,3-3V11A3,3,0,0,0,27,8Zm0,2a1,1,0,0,1,1,1v1.17A3,3,0,0,0,27,12H24.94A8.39,8.39,0,0,0,25,11a8.26,8.26,0,0,0-.06-1ZM16,4a7,7,0,0,1,7,7,6.73,6.73,0,0,1-.07,1h-4.1a3,3,0,0,0-2.78-2H16a1,1,0,1,1,1-1,1,1,0,0,0,2,0,3,3,0,0,0-2-2.83V6a1,1,0,0,0-2,0v.17A3,3,0,0,0,16,12H9.07A6.73,6.73,0,0,1,9,11,7,7,0,0,1,16,4ZM5,10H7v2H5a1,1,0,0,1,0-2ZM27,28H5a1,1,0,0,1-1-1V13.83A3,3,0,0,0,5,14H27a1,1,0,0,1,1,1v2H25a4,4,0,0,0,0,8h3v2A1,1,0,0,1,27,28Zm1-5H25a2,2,0,0,1,0-4h3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17,20H15a1,1,0,0,0,0,2h2a1,1,0,0,0,0-2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.14f1243786bf469788b22bfa59bc0dfc.svg";
export { ForwardRef as ReactComponent };